import React from 'react';
import {ReactComponent as MarkerIco} from "../../../../../images/icons/marker.svg";
import {useTranslation} from "react-i18next";
import {ReactComponent as ShareIco} from "../../../../../images/icons/share.svg";
import {FormattedPhoneNumber, getFormattedPhoneNumber} from "../../../Common/FormattedPhoneNumber";
import {ConfigApi} from "../../../../services/Api/types";
import {ReactComponent as PhoneIco} from "../../../../../images/icons/phone.svg";
import {ReactComponent as EmailIco} from "../../../../../images/icons/email.svg";

interface Props {
    address: string | undefined;
    renderListItem: (
        icon: any,
        title: string,
        value: any,
        shareIcon: any,
        link?: any,
        action?: any,
    ) => any;
    config: ConfigApi;
}

const FooterStoreDetails = ({address, renderListItem, config}: Props) => {
    const {t} = useTranslation();

    return (
        <>
            {address && (
                <li>
                    <div className="footer-list-item-wrapper">
                        {renderListItem((<MarkerIco/>), t("common.word.address"),
                            address,
                            (<ShareIco aria-hidden="true"/>),
                            `https://maps.google.com/?q=${address}`
                        )}
                    </div>
                </li>
            )}
            {config?.contact?.phone && (
                <li>
                    <div className="footer-list-item-wrapper">
                        {renderListItem((<PhoneIco/>), t("common.word.phone_number"),
                            <FormattedPhoneNumber countryCode="PL"
                                                  phoneNumber={config.contact.phone}/>,
                            (<ShareIco aria-hidden="true"/>),
                            `tel:${getFormattedPhoneNumber("", config.contact.phone)}`
                        )}
                    </div>
                </li>
            )}
            {config?.contact?.email && (
                <li>
                    <div className="footer-list-item-wrapper">
                        {renderListItem((<EmailIco/>), t("common.word.email"),
                            config.contact.email,
                            (<ShareIco aria-hidden="true"/>),
                            `mailto:${config.contact.email}`
                        )}
                    </div>
                </li>
            )}
        </>
    )
}

export default FooterStoreDetails;